<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  require('@fortawesome/free-solid-svg-icons/faSync').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronDown').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronUp').definition,
  require('@fortawesome/free-solid-svg-icons/faCheck').definition,
  require('@fortawesome/free-solid-svg-icons/faCheckCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faTimes').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowRight').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowDown').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowUp').definition,
  require('@fortawesome/free-solid-svg-icons/faSearch').definition,
  require('@fortawesome/free-solid-svg-icons/faFilter').definition,
  require('@fortawesome/free-solid-svg-icons/faTimes').definition,
  require('@fortawesome/free-solid-svg-icons/faCheck').definition,
  require('@fortawesome/free-solid-svg-icons/faExclamationCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faInfoCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faSignOutAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faCog').definition,
  require('@fortawesome/free-solid-svg-icons/faHome').definition,
  require('@fortawesome/free-solid-svg-icons/faCalendar').definition,
  require('@fortawesome/free-solid-svg-icons/faPlusSquare').definition,
  require('@fortawesome/free-solid-svg-icons/faBullhorn').definition,
  require('@fortawesome/free-solid-svg-icons/faHistory').definition,
  require('@fortawesome/free-solid-svg-icons/faChartBar').definition,
  require('@fortawesome/free-solid-svg-icons/faExclamationTriangle').definition,
  require('@fortawesome/free-solid-svg-icons/faColumns').definition,
  require('@fortawesome/free-solid-svg-icons/faChartArea').definition,
  require('@fortawesome/free-solid-svg-icons/faDownload').definition,
  require('@fortawesome/free-solid-svg-icons/faPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faMinus').definition,
  require('@fortawesome/free-solid-svg-icons/faCaretDown').definition,
  require('@fortawesome/free-solid-svg-icons/faCaretUp').definition,
  require('@fortawesome/free-solid-svg-icons/faPhone').definition,
  require('@fortawesome/free-solid-svg-icons/faHandshake').definition,
  require('@fortawesome/free-solid-svg-icons/faExchangeAlt').definition
)

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <FontAwesomeIcon
    v-bind="$attrs"
    :icon="name"
  />
</template>
